import type { AppLolRegion } from "@core-types/region.enum";

export enum EProductStatus {
  SEMI_READY = "SEMI_READY",
  RANKED_READY = "RANKED_READY",
}

interface IProduct {
  id: number;
  i18nKey: string;
  slug: string;
  slugFr?: string;
  slugEn?: string;
  price: number;
  thumbnail: string;
  blueEssence: string;
  status: EProductStatus;
  accounts: number[];
  categorySlug: string;
  availableIn: AppLolRegion[];
}

export default IProduct;
